import { cx } from "@its-engineering-and-development/ui-foundation/utils";
import type { ReactNode } from "react";

/** List row shell used by dashboard summary cards (matches Figma #F7F8F9 tiles). */
export const DASHBOARD_LIST_ROW_CLASS = "flex items-center gap-3 rounded-lg bg-[#F7F8F9] px-3 py-3";

export function DashboardListRow({ children, className }: { children: ReactNode; className?: string }) {
    return <li className={cx(DASHBOARD_LIST_ROW_CLASS, className)}>{children}</li>;
}
